import api from './index'

/**
 * Submit a patient's interest in being notified about future studies.
 * Requires authentication.
 * @param {string} studyInterest - The patient's description of what studies they're looking for
 * @returns {Promise<Object>} API response with status
 */
export async function submitPatientStudyInterest(studyInterest) {
  const response = await api.post('/api/patient/study-interest', { study_interest: studyInterest })
  return response.data
}
